/**
 * Memoized gate configuration card.
 * Prevents re-renders when other gates change.
 */
import { memo } from "react";

export interface GateConfigCardProps {
  link: { id: string; source_id: string; target_id: string };
  currentType?: string;
  onSetGate: (
    linkId: string,
    config:
      | { type: "multisig" | "whitelist" | "rate_limit"; config: Record<string, unknown> }
      | undefined,
  ) => void;
}

export const GateConfigCard = memo<GateConfigCardProps>(({ link, currentType, onSetGate }) => (
  <div className="p-4 bg-sa-surface-hover rounded-lg border border-sa-border">
    <div className="flex items-center justify-between mb-3">
      <span className="font-medium text-sa-text">
        {link.source_id} → {link.target_id}
      </span>
      <span className="text-xs text-sa-warning">(value flow)</span>
    </div>
    <div className="flex gap-2">
      {(["multisig", "whitelist", "rate_limit"] as const).map((type) => (
        <button
          key={type}
          onClick={() =>
            onSetGate(link.id, currentType === type ? undefined : { type, config: {} })
          }
          className={`px-3 py-1.5 text-xs font-medium rounded transition-colors ${
            currentType === type
              ? "bg-green-600 text-white"
              : "bg-sa-surface-hover text-sa-text hover:bg-sa-border"
          }`}
        >
          {type.replace("_", " ")}
        </button>
      ))}
    </div>
  </div>
));

GateConfigCard.displayName = "GateConfigCard";
